import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChannelId = string;
export type UserChannelPermissionReducerState = {
  userChannelPermission: Record<ChannelId, TUserChannelPermission | null>;
};
export const initialState: UserChannelPermissionReducerState = {
  userChannelPermission: {},
};

export const userChannelPermissionSlice = createSlice({
  name: "userChannelPermission",
  initialState,
  reducers: {
    setUserChannelPermission: (
      state: UserChannelPermissionReducerState,
      action: PayloadAction<{
        channelId: ChannelId;
        userChannelPermission: TUserChannelPermission | null;
      }>,
    ) => {
      state.userChannelPermission[action.payload.channelId] =
        action.payload.userChannelPermission;
    },
    resetUserChannelPermission: (
      state: UserChannelPermissionReducerState,
      action: PayloadAction<ChannelId>,
    ) => {
      state.userChannelPermission[action.payload] = {
        createPost: false,
        readPost: false,
        readMemberList: false,
        createReaction: false,
        createComment: false,
        deletePost: false,
        deleteComment: false,
        createLiveStreaming: false,
        watchLiveStreaming: false,
      };
    },
  },
});

export const { setUserChannelPermission, resetUserChannelPermission } =
  userChannelPermissionSlice.actions;

export default userChannelPermissionSlice.reducer;
